(() => {
  class GJHomeCarousel extends HTMLElement {
    connectedCallback() {
      if(this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-gj-slide]')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.toggle = this.querySelector('[data-toggle]');
      if(this.slides.length < 2 || !this.toggle) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 5000);
      this.style.setProperty('--gj-carousel-duration', this.interval + 'ms');
      this.querySelector('.gj-hpc__controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), {signal});
      this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.index)), {signal}));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => this.schedule(), {signal});
      this.addEventListener('focusout', () => this.schedule(), {signal});
      this.addEventListener('keydown', e => {
        if(e.target.closest('button') && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          e.preventDefault(); this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.addEventListener('pointerdown', e => { if(e.pointerType === 'touch') this.touch = {x:e.clientX,y:e.clientY}; }, {signal});
      this.addEventListener('pointerup', e => {
        if(!this.touch || e.pointerType !== 'touch') return;
        const dx = e.clientX - this.touch.x, dy = e.clientY - this.touch.y;
        this.touch = null;
        if(Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
      }, {signal});
      this.addEventListener('pointercancel', () => { this.touch = null; }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', e => { if(e.matches) this.paused = true; this.schedule(); }, {signal});
      this.addEventListener('shopify:block:select', e => {
        const at = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if(at >= 0) this.show(at);
      }, {signal});
      this.show(0);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
        slide.inert = !active;
        const photo = slide.querySelector('.gj-hpc__photo');
        if(photo) photo.tabIndex = active ? 0 : -1;
      });
      this.dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-count]').textContent = String(this.index + 1);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if(!this.toggle) return;
      const focused = document.activeElement;
      const keyboardReading = this.contains(focused) && focused.closest('[data-gj-slide]') && focused.matches(':focus-visible');
      const running = !this.paused && !document.hidden && !keyboardReading;
      this.dataset.runState = running ? 'playing' : 'paused';
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.querySelector('[data-toggle-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
      const progress = this.querySelector('[data-progress]');
      if(progress) {
        progress.style.animation = 'none';
        void progress.offsetWidth;
        progress.style.animation = running ? 'gj-hpc-progress var(--gj-carousel-duration) linear forwards' : 'none';
      }
      if(running) this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
  }
  if(!customElements.get('gj-home-product-carousel')) customElements.define('gj-home-product-carousel',class extends GJHomeCarousel {});
  if(!customElements.get('gj-home-supply-carousel')) customElements.define('gj-home-supply-carousel',class extends GJHomeCarousel {});
})();
